/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

import PiedInsee from './PiedInsee';
import type { VueInsee } from './types';

interface ModalInseeProps {
  vue: VueInsee;
  open: boolean;
  onClose: () => void;
  'data-testid': string;
}

/** Écran INSEE en modale, ouvert depuis le tableau de bord */
const ModalInsee = ({
  vue,
  open,
  onClose,
  'data-testid': testId,
}: ModalInseeProps) => (
  <>
    <Modal
      open={open}
      onClose={onClose}
      size="large"
      // Un peu plus large que « large » (1080px) pour le tableau et le panneau latéral
      style={{ width: 1280, maxWidth: '95vw' }}
      closeIcon
      data-testid={testId}
    >
      <Modal.Header content={vue.titre} />
      <Modal.Content>{vue.corps}</Modal.Content>
      <Modal.Actions>
        <PiedInsee message={vue.message}>
          <Button
            basic
            size="small"
            icon="close"
            content="Fermer"
            onClick={onClose}
            data-testid={`${testId}-fermer`}
          />
          {vue.boutons}
        </PiedInsee>
      </Modal.Actions>
    </Modal>
    {vue.dialogues}
  </>
);

export default ModalInsee;
